<mat-chip-listbox>
  <mat-chip-option (click)="clearAll()" highlighted *ngIf="dataSource?.length && clearAllChip" [selectable]="selectable" class="clear-all" i18n>Clear all</mat-chip-option>
  <mat-chip-option
    [ngClass]="chipViewMode === 'view' && chipViewModeClasses.length === 0 ? 'sp-chips' : chipViewModeClasses"
    *ngFor="let list of dataSource"
    [removable]="true"
    (removed)="remove(list)"
    [highlighted]="chipViewMode !== 'view' && highlighted"
    [selectable]="chipViewMode !== 'view' && selectable"
    (click)="selectedChips.emit(list)"
    disableRipple="true"
  >
    <div class="flex items-center">
      <sp-avatar *ngIf="showAvatar" class="-ml-2" [user]="list" [size]="25" [fontSize]="12" [showToolTip]="false"> </sp-avatar>
      <span [ngClass]="{ 'ml-2': showAvatar }">{{ displayList(list) | async }}</span>
      <button matChipRemove *ngIf="chipViewMode !== 'view' && isString(list) && !list.includes('(+')">
        <mat-icon>close</mat-icon>
      </button>
      <button matChipRemove *ngIf="chipViewMode !== 'view' && !isString(list)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-chip-option>
</mat-chip-listbox>
